import {createSelector} from 'reselect';

import {AppState} from '../../configStore';

export const selectCurrentModal = (state: AppState) => state.currentModal;
export const selectCurrentModalName = createSelector(selectCurrentModal, currentModal => currentModal?.name || '');
